/**
 * @author  Kheops Technologies SA <devops@kheops.ch>
 * @copyright Kheops Technologies SA
 */
import KhVueAttachable from './KhVueAttachable.vue'
export * from './KhVueAttachable.vue'
export default KhVueAttachable
